import { create } from "zustand";

type NewCaseState = {
  open: boolean;
  /** Preselects this client and starts at the workflow question. */
  clientId: string | null;
  /** Bumped on every open so the wizard starts fresh. */
  session: number;
};

export const useNewCaseStore = create<NewCaseState>(() => ({
  open: false,
  clientId: null,
  session: 0
}));

/** Open the New Case modal over the current screen. */
export const openNewCase = (options: { clientId?: string | null } = {}) =>
  useNewCaseStore.setState((s) => ({
    open: true,
    clientId: options.clientId?.trim() || null,
    session: s.session + 1
  }));

export const closeNewCase = () =>
  useNewCaseStore.setState({ open: false, clientId: null });
